<template>
  <div class="addedit-lead center">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ editRoute ? $t('labels.edit_port') : $t('labels.add_port') }}</h2>
      </div>
    </div>
    <form @submit.prevent="checkValidation()" autocomplete="off">
      <vx-card class="addedit-lead-card">
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
            <label>{{$t('labels.name')}}</label>
            <vs-input
              type="text"
              class="w-full mt-1"
              name="port_name"
              maxlength="50"
              v-model="name"
              icon-no-border
              :placeholder="$t('labels.port_name')"
              v-validate="'required|max:50'"
            />
            <span class="text-danger text-sm">{{ errors.first('port_name') }}</span>
          </div>
          <div class="vx-col sm: w-full md:w-1/2 mb-4 pr-0">
            <label>{{ $t('labels.country')}}</label>
            <v-select
              class="w-full mt-1"
              v-model="country_id"
              :options="countries"
              name="country"
              :reduce="country => country.id"
              label="name"
              v-validate="'required'"
            />
            <span class="text-danger text-sm">{{ errors.first('country') }}</span>
          </div>
        </div>
        <div class="mt-2\ btn-lead flex justify-center">
          <vs-button
            class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
            :disabled="button_loading"
            id="create-port"
            button="submit"
          >{{ editRoute ? $t('labels.update_port') : $t('labels.add_port') }}</vs-button>
        </div>
      </vx-card>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      country_id: "",

      // select
      countries: []
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    this.getCountries();
    if (this.editRoute) {
      this.getPort();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdatePort();
        }
      });
    },
    async getCountries() {
      let response = await this.getHTTPPostResponse("/country/list");
      if (response) {
        let data = response.data;
        let countries = data.countries;
        this.countries = countries;
      }
    },
    async createUpdatePort() {
      let input = {
        name: this.name,
        country_id: this.country_id
      };
      let url = this.editRoute
        ? "/ports/update/" + this.editRoute
        : "/ports/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-port",
        true
      );
      if (response) {
        this.$router.push({ name: "Ports" });
      }
    },
    async getPort() {
      let response = await this.getHTTPGetResponse(
        "/ports/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let port = data.port;
        this.name = port.name;
        this.country_id = port.country_id;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>